"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MarkdownListItem;
var _react = _interopRequireDefault(require("react"));
/*:: // 

import { type Node } from 'react';*/
/*:: type Props = {
  /**
   * Child nodes
   *-/
  children?: Node
};*/
function MarkdownListItem(_ref /*:: */) /*: Node*/{
  var children = _ref /*:: */.children;
  return /*#__PURE__*/_react.default.createElement("li", null, children);
}
MarkdownListItem.displayName = 'MarkdownListItem';
//# sourceMappingURL=ListItem.js.map